app.factory('userService', ['$q', 'baseService', 'objectHelper', 'config',
  function ($q, baseService, objectHelper, config) {
    
    function UserService() {
      
      this.getDataPage = function (criteria) {
        return baseService.post(config.API_URL + '/users/dataPage', criteria).then(
          function (successResponse) {
            var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
            dataPage.data = objectHelper.translateArray(dataPage.data, UserVO);
            
            return dataPage;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.getById = function (id) {
        return baseService.get(config.API_URL + '/users/' + id).then(
          function (successResponse) {
            var data = objectHelper.translateObject(successResponse, UserVO);
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.save = function (user) {
        return baseService.post(config.API_URL + '/users/save', user).then(
          function (successResponse) {
            var data = objectHelper.translateObject(successResponse, UserVO);
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.update = function (user) {
        return baseService.post(config.API_URL + '/users/update', user).then(
          function (successResponse) {
            var data = objectHelper.translateObject(successResponse, UserVO);
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.deleteAll = function (users) {
        return baseService.post(config.API_URL + '/users/deleteAll', users).then(
          function (successResponse) {
            return successResponse;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.updateStatus = function (user) {
        return baseService.post(config.API_URL + '/users/updateStatus', user).then(
          function (successResponse) {
            return successResponse;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.changePassword = function (oldPassword, newPassword) {
        var changePasswordWrapper = {
          oldPassword: oldPassword,
          newPassword: newPassword
        };
        
        return baseService.post(config.API_URL + '/users/changePassword', changePasswordWrapper).then(
          function (successResponse) {
            var data = objectHelper.translateObject(successResponse, UserVO);
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.resetPassword = function (user) {
        return baseService.post(config.API_URL + '/users/resetPassword', user).then(
          function (successResponse) {
            return successResponse;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.getLoggedUser = function () {
        return baseService.post(config.API_URL + '/users/getLoggedUser').then(
          function (successResponse) {
            var data = objectHelper.translateObject(successResponse, LoggedUserVO);
            
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
      
      this.getRoleList = function (criteria) {
        return baseService.post(config.API_URL + '/users/getRoleList', criteria).then(
          function (successResponse) {
            var data = objectHelper.translateArray(successResponse, RoleVO);
            return data;
          },
          function (errorResponse) {
            return $q.reject(errorResponse);
          }
        );
      };
    }
    
    return new UserService();
  }
  
]);
